import React from "react";
import { Bar } from "react-chartjs-2";
import states from "../../../components/states";
import { formatDate } from "date-fns";
import blueColors from "../../../Home/components/blueColors";
import { Box, Typography, CircularProgress } from "@mui/material";

const VolumeBarChart = ({ dataSource }) => {
  let volumes = [];
  let dates = [];
  let statesArray = [];

  dataSource.forEach((feature) => {
    volumes.push(feature.properties.volume);
    dates.push(feature.properties.acquisition_info.date);
    statesArray.push(states[feature.properties.state]);
  });

  const formatTimeLabel = (value) => {
    return formatDate(new Date(value), "yyyy/MM/dd");
  };

  const data = {
    labels: dates.map(formatTimeLabel),
    datasets: [
      {
        label: "Volume (barrels)",
        data: volumes,
        backgroundColor: blueColors,
        borderColor: blueColors,
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
      },
      title: {
        display: false,
      },
    },
    scales: {
      x: {
        ticks: {
          autoSkip: true,
          maxRotation: 45,
          minRotation: 0,
          maxTicksLimit: 10,
        },
        reverse: true,
      },
      y: {
        ticks: {
          autoSkip: true,
          maxTicksLimit: 5,
        },
      },
    },
  };

  if (!dataSource) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "15vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }
  if (dataSource.length === 0) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "15vh",
        }}
      >
        <Typography variant="h6">No volume data available</Typography>
      </Box>
    );
  }
  return (
    <Box className="volume-bar-chart">
      <Bar data={data} options={options} />
    </Box>
  );
};

export default VolumeBarChart;
